import { parse as _parse, prop as _prop } from "./template-parser";
export var parse = _parse;
export var prop = _prop;
